<template>
    <navigation />

    <products :limit="1000" />

    <pricing />

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import Products from "../partials/Products.vue";
import Pricing from "../partials/Pricing.vue";
import SiteFooter from "../partials/SiteFooter.vue";

export default {
    name: "Material",

    components: {
        Navigation,
        Products,
        Pricing,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("material.title")}`,
        };
    },
};
</script>
